export const encryption_key = "bc397Zam6e7&^^%mfd-d0PlaPliyaf1-+9wh4defSu-9a7dr-9647sub43re706veyeb";